import React from 'react'
import LoginComponent from './components/index.component'

const LoginModule = () => {
  return <LoginComponent />
}

export default LoginModule
